import {
  AUTHENTICATING_SUITECRM_REQUEST, AUTHENTICATING_SUITECRM_SUCCEDDED, AUTHENTICATING_SUITECRM_FAILED,
  UPDATING_SUITECRM_REQUEST, UPDATING_SUITECRM_SUCCEDDED, UPDATING_SUITECRM_FAILED,
  SYNCHRONISING_SUITECRM_REQUEST, SYNCHRONISING_SUITECRM_SUCCEDDED, SYNCHRONISING_SUITECRM_FAILED,
  FETCHING_SUITECRM_SYNC_DETAILS_REQUEST, FETCHING_SUITECRM_SYNC_DETAILS_SUCCEDDED, FETCHING_SUITECRM_SYNC_DETAILS_FAILED,

  FETCHING_SUITECRM_MASTER_CONFIG_REQUEST, FETCHING_SUITECRM_MASTER_CONFIG_SUCCEDDED, FETCHING_SUITECRM_MASTER_CONFIG_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  config: {
    loading: false,
    item: null,
    error: null
  },
  synchronisation: {
    synchronising: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function suitecrmReducer(state = initialState, action) {
  switch (action.type) {
     case AUTHENTICATING_SUITECRM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_SUITECRM_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_SUITECRM_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 

     case UPDATING_SUITECRM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_SUITECRM_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_SUITECRM_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })

    case FETCHING_SUITECRM_MASTER_CONFIG_REQUEST:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: true,
          error: null
        }
      })
    case FETCHING_SUITECRM_MASTER_CONFIG_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: action.payload,
          error: null
        }
      })
    case FETCHING_SUITECRM_MASTER_CONFIG_FAILED:
      return Object.assign({}, state, {
        ...state,
        config: {
          loading: false,
          item: null,
          error: action.payload
        }
      })  

    case SYNCHRONISING_SUITECRM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: true,
          error: null
        }

      })
    case SYNCHRONISING_SUITECRM_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: null
        }
      })
    case SYNCHRONISING_SUITECRM_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: false,
          error: action.payload
        }
      }) 

    case FETCHING_SUITECRM_SYNC_DETAILS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: null
        }

      })
    case FETCHING_SUITECRM_SYNC_DETAILS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          synchronising: action.payload.syncInProgress,
          error: null
        }
      })
    case FETCHING_SUITECRM_SYNC_DETAILS_FAILED:
      return Object.assign({}, state, {
        ...state,
        synchronisation: {
          error: action.payload
        }
      }) 

    default:
      return state
  }
}

export { suitecrmReducer };